'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFolderOpenO = function FaFolderOpenO(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37 20.7q0-0.7-1.1-0.7h-22.6q-0.8 0-1.8 0.4t-1.5 1.1l-6.1 7.6q-0.3 0.5-0.3 0.8 0 0.7 1.1 0.7h22.5q0.9 0 1.8-0.4t1.5-1.1l6.1-7.6q0.4-0.4 0.4-0.8z m-23.7-3.4h15.9v-3.3q0-0.8-0.5-1.4t-1.5-0.6h-11.9q-0.8 0-1.4-0.6t-0.6-1.4v-1.3q0-0.8-0.6-1.4t-1.4-0.6h-6.6q-0.9 0-1.5 0.6t-0.5 1.4v17.7l5.3-6.5q0.9-1.1 2.4-1.8t2.9-0.8z m26.3 3.4q0 1.3-0.9 2.5l-6.1 7.6q-0.9 1.1-2.5 1.8t-2.9 0.7h-22.5q-2 0-3.3-1.4t-1.4-3.3v-19.9q0-1.9 1.4-3.3t3.3-1.3h6.6q1.9 0 3.3 1.3t1.3 3.3v0.7h11.3q2 0 3.3 1.3t1.4 3.3v3.3h4q1.1 0 2 0.6t1.4 1.4q0.3 0.7 0.3 1.4z' })
        )
    );
};

exports.default = FaFolderOpenO;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/folder-open-o.js
// module id = 290
// module chunks = 58411574672382 79611799117203 84521481881339 164655002686464